module.exports = __webpack_public_path__ + "static/media/malawi-shipping-map.47087f3e.jpg";